<template>
  <div class="order-query">
    <header class="page-header">
      <van-icon name="arrow-left" @click="$router.go(-1)" />
      <span>{{ title }}</span>
      <span></span>
    </header>
    <main class="page-body">
      <van-tabs @click="onSearch" v-model="activeName">
        <van-tab :title="$t('全部')" name="all" :badge="stats.od_Total">
        </van-tab>
        <van-tab
          :title="$t('待处理')"
          name="waitprocessing"
          :badge="stats.od_WaitAction"
        >
        </van-tab>
        <van-tab
          :title="$t('已测量')"
          name="yiceliang"
          :badge="stats.od_WaitForShip"
        >
        </van-tab>
        <van-tab
          :title="$t('待支付')"
          name="waitpay"
          :badge="stats.od_UnpayExp"
        >
        </van-tab>
        <van-tab
          :title="$t('已装柜')"
          name="yizhuanggui"
          :badge="stats.od_Loaded"
        >
        </van-tab>
      </van-tabs>
      <div class="flexbox">
        <van-search
          class="flex-fill"
          v-model="keyword"
          show-action
          :placeholder="$t('请输入搜索关键词')"
          @search="onSearch"
        >
          <template #action>
            <div @click="onSearch">{{ $t('搜索') }}</div>
          </template>
        </van-search>
      </div>
      <div
        class="van-cell  van-field"
        style="border-bottom: 1px solid #efefef;"
      >
        <div class="van-cell__value van-field__value">
          <div class="van-field__body">
            <input type="date" v-model="startDate" class="date-input" />
          </div>
        </div>
        <div
          class="van-cell__title van-field__label"
          style="text-align: center;"
        >
          -
        </div>
        <div class="van-cell__value van-field__value">
          <div class="van-field__body">
            <input type="date" v-model="endDate" class="date-input" />
          </div>
        </div>
      </div>
      <section v-if="list.length > 0">
        <section class="list padding" :style="[bodyHeight]">
          <div class="card" v-for="(item, index) in list" :key="index">
            <template v-if="$route.query.type === 'order'">
              <header class="flexbox space-bt card-header">
                <div>{{ $t('订单号') }} ：{{ item.sOrderNo | empty }}</div>
                <div class="theme-color">{{ $t(item.StatusDesc) }}</div>
              </header>
              <div
                class="card-body flexbox space-bt"
                @click="
                  $router.push({
                    name: 'OrderDetail',
                    query: { orderno: item.sOrderNo },
                  })
                "
              >
                <div>
                  <div>
                    {{ $t('唛头') }}：<span class="theme-color">{{
                      item.sShipMark
                    }}</span>
                  </div>
                  <div>
                    {{ $t('收件人') }}：<span class="theme-color">{{
                      item.sRecName
                    }}</span>
                  </div>
                  <div>
                    <span>
                      {{ $t('收货电话') }}：<span class="theme-color">
                        {{ item.sRecTel }}</span
                      ></span
                    >
                  </div>
                  <div>
                    {{ $t('收件地址') }}：{{
                      (item.sCnCountryName == null ? '' : item.sCnCountryName) +
                        ' ' +
                        (item.sRecCity == null ? '' : item.sRecCity) +
                        ' ' +
                        (item.sAddr1 == null ? '' : item.sAddr1) +
                        ' ' +
                        (item.sAddr2 == null ? '' : item.sAddr2)
                    }}
                  </div>
                  <div>{{ $t('物品名称') }}：{{ item.goods_name | empty }}</div>
                  <div>{{ $t('备注') }}：{{ item.remark | empty }}</div>
                  <div v-if="appTitle != 'Love Logistic'">
                    {{ $t('货值') }}：{{ item.fDeclareValue | empty }}
                  </div>
                  <div>
                    {{ $t('运输方式') }}:
                    <span class="round-label"> {{ $t(item.transType) }}</span>
                  </div>
                  <div>{{ $t('发货日期') }}: {{ item.createtime | time }}</div>
                  <div class="flexbox">
                    <div
                      v-if="
                        userInfo.bWatchVol != null &&
                          userInfo.bWatchVol == true &&
                          item.totalVol > 0
                      "
                    >
                      {{ $t('体积') }}：<span class="order-info-item">{{
                        item.totalVol | empty
                      }}</span>
                    </div>
                    <div
                      v-if="
                        userInfo.bWatchVol != null &&
                          userInfo.bWatchVol == true &&
                          item.totalWeight > 0
                      "
                    >
                      {{ $t('重量') }}：<span class="order-info-item">{{
                        item.totalWeight | empty
                      }}</span>
                    </div>
                    <div>
                      {{ $t('箱数') }}：<span class="order-info-item">{{
                        item.totalBags | empty
                      }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <footer class="card-footer">
                <span class="pull-left"
                  >{{ $t('目的地') }}：<span class="round-label">
                    {{ item.targetPlace }}</span
                  >
                </span>
                <!-- <a class="round-label" :href="'/tracks?key=' + item.sOrderNo"
                >轨迹详情</a
              > -->
              </footer>
            </template>
          </div>
        </section>
        <div class="pagination">
          <van-pagination
            @change="onSearch"
            v-model="currentPage"
            :total-items="totalCount"
            :items-per-page="limit"
            :show-page-size="4"
            force-ellipses
          />
        </div>
      </section>
      <section v-else class="padding no-item">
        <div class=""><img :src="emptyImg" /></div>
        <div class="nodesc">{{ $t('暂时没有待处理记录') }}</div>
      </section>
    </main>
  </div>
</template>
<script>
import { getOrderList, getStatsData } from '@/api/deliver.js';
import { BASE_TMS_URL, APP_TITLE } from '@/api/index.js';
import { ImagePreview } from 'vant';
import { $t } from '@/plugins/i18n';

export default {
  props: {
    status: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      appTitle: APP_TITLE,
      keyword: '',
      list: [],
      activeName: 'all',
      emptyImg: require('../../assets/images/noinfo.png'),
      userInfo: this.$store.getters.userInfo,
      tms_img_url: BASE_TMS_URL,
      totalCount: 0,
      currentPage: 1,
      limit: 15,
      state: -100,
      bodyHeight: { height: '644px', overflow: 'auto' },
      startDate: null,
      endDate: null,
      tabAciveDict: {
        '-10': 'all',
        0: 'waitprocessing',
        '-200': 'waitpay',
        '-14': 'yizhuanggui',
      },
      stats: {},
    };
  },
  computed: {
    title() {
      const typeKv = {
        order: $t('运单中心'),
      };

      const orderMap = {
        '-200': $t('待支付'),
        '-1': $t('已取消'),
        '0': $t('待处理'),
        '1': $t('待装车'),
        '-14': $t('已装柜'),
        '2': $t('运输中'),
        '11': $t('已收货'),
        '-3': $t('问题单'),
        '-10': $t('全部订单'),
        '-11': $t('退货单'),
        '-12': $t('已取消'),
        '-100': $t('处理中'),
        '-101': $t('在途'),
      };
      const q = this.$route.query;

      if (q.type === 'order') {
        return `${typeKv.order}-${orderMap[q.status]}`;
      }
      return $t('订单查询');
    },
  },
  mounted() {
    let hei = window.innerHeight - 278;
    this.bodyHeight.height = hei + 'px';
    const q = this.$route.query;
    this.activeName = this.tabAciveDict[q.status];
    this.loadData();
  },
  methods: {
    loadData() {
      this.$toast.loading();
      getStatsData({})
        .then(res => {
          this.stats = res;
        })
        .finally(() => {
          this.$toast.clear();
        });

      this.onSearch();
    },
    onSearch() {
      const q = this.$route.query;
      let name = this.activeName;
      this.state = -2;
      let _dabao = -2;
      let _measure = -2;
      let paystate = -2;
      if (name == 'all') {
        this.state = -100;
      } else if (name == 'waitprocessing') {
        //待打包,待测量，
        _dabao = -2;
        this.state = 0;
      } else if (name == 'daiceliang') {
        _dabao = 1;
        _measure = 2; //未测量
      } else if (name == 'yiceliang') {
        _dabao = 2;
        _measure = 1; //已测量
        this.state = 0;
      } else if (name == 'daizhuanggui') {
        this.state = -13;
      } else if (name == 'yizhuanggui') {
        this.state = -14;
      } else if (name == 'waitpay') {
        this.state = 1;
        paystate = 2; //待支付
      } else {
        this.state = q.status;
      }

      let offcount = (this.currentPage - 1) * this.limit;
      getOrderList({
        keyword: this.keyword,
        state: this.state,
        dabao: _dabao,
        measure: _measure,
        paystate: paystate,
        startDate: this.startDate,
        endDate: this.endDate,
        limit: this.limit,
        offset: offcount,
      }).then(res => {
        this.list = res.rows;
        this.totalCount = res.total;
      });
    },
    onImgPreview(imgurl) {
      if (imgurl == '' || imgurl == null) {
        return;
      }
      ImagePreview([imgurl]);
    },
  },
};
</script>
<style lang="scss" scoped>
@import '~@/styles/_var';
.card {
  padding: rem(20px);
  padding-top: 0;
  border-radius: rem(15px);
  box-shadow: 0px 2px 10px 0px rgba(14, 48, 53, 0.1);
  background-color: #fff;
  .card-header {
    color: #b8b8b8;
    font-size: 12px;
    border-bottom: 1px solid #efefef;
    height: rem(53px);
    line-height: rem(53px);
  }
  .card-body {
    padding: rem(20px) 0;
    border-bottom: 1px solid #efefef;
    line-height: rem(52px);
  }
  .card-footer {
    color: #666;
    padding-top: rem(20px);
    height: rem(30px);
  }
  & + .card {
    margin-top: rem(20px);
  }
  .foot-desc {
    font-size: rem(26px);
    border-color: #b9aebb;
    border: 1px solid;
    color: #b9aebb;
    padding: 0 10px;
    border-radius: 4px;
    margin-right: 0.26rem;
  }
}
.padding {
  padding: rem(20px);
}
.img {
  width: rem(280px);
  height: rem(150px);
}
.pagination {
  margin: rem(10px);
}
.van-pagination__item {
  color: #b9aebb;
}
.van-pagination__item
  .van-pagination__item--active
  .van-pagination__page
  .van-hairline {
  color: #fff;
  background-color: #b9aebb;
}
.noimg {
  width: auto;
  height: rem(150px);
}

.no-item {
  text-align: center;
  margin: rem(40px);
  img {
    height: rem(249px);
  }
  .no-desc {
    font-size: rem(13px);
    text-align: center;
  }
}

.round-label {
  background: #b9aebb;
  color: #fff;
  padding: 3px;
  border-radius: 3px;
  margin: 0 5px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.order-info-item {
  border-color: #b9aebb;
  border: 1px solid;
  color: #b9aebb;
  padding: 0px 10px;
  border-radius: 4px;
  margin-right: rem(20px);
}
.date-input {
  border: 0;
}
</style>
